import React from "react";
import { Download, Settings, MessageSquare, Sparkles } from "lucide-react";
import { useLanguage } from "@/i18n";

const stepIcons = [Download, Settings, MessageSquare, Sparkles];

const HowItWorksSection = () => {
  const { t } = useLanguage();
  const steps = t('howItWorks.steps');

  return (
    <section className="py-20 sm:py-28 px-4 relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent pointer-events-none" />
      
      <div className="max-w-6xl mx-auto relative z-10">
        {/* Section header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-primary text-sm font-medium uppercase tracking-widest">
            {t('howItWorks.label')}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground">
            {t('howItWorks.title')}{" "}
            <span className="text-gradient">{t('howItWorks.titleHighlight')}</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const Icon = stepIcons[index];
            return (
              <div
                key={index}
                className="relative text-center group"
              >
                {/* Connector line (hidden on mobile, last item) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-[60%] w-full h-px bg-gradient-to-r from-border to-transparent" />
                )}
                
                {/* Step number & icon */}
                <div className="relative inline-flex flex-col items-center">
                  <div className="relative">
                    <div className="w-20 h-20 rounded-2xl bg-card border border-border flex items-center justify-center group-hover:border-primary/50 transition-colors duration-300">
                      <Icon className="w-8 h-8 text-primary" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-lg bg-primary text-primary-foreground text-sm font-bold flex items-center justify-center">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                  </div>
                </div>
                
                {/* Content */}
                <div className="mt-6 space-y-2">
                  <h3 className="text-lg font-semibold text-foreground">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
